import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";
import type { MfaSettingsReq } from "./type";

export const getMfaSettings = async () => {
  const res = await apiClient.GET("/v2/settings/mfa");
  return getDataOrThrowApiError(res);
};

export const updateMfa = async (requestData: MfaSettingsReq) => {
  const res = await apiClient.PATCH("/v2/settings/mfa/email", {
    body: requestData,
  });
  return getDataOrThrowApiError(res);
};
